import memoizeFormatConstructor from 'intl-format-cache';
import { getSanitizedLocaleForIntl } from './localeUtils';
var getNumberFormat = memoizeFormatConstructor(Intl.NumberFormat);
var getDateTimeFormat = memoizeFormatConstructor(Intl.DateTimeFormat);
var I18nFormatter = {
  /**
   * Formats the specified amount for the given locale and currency.
   * This logic was taken from https://github.homeawaycorp.com/hacommons/hacommons-i18n/blob/master/src/main/java/com/homeaway/commons/i18n/formatter/GlobalCurrencyFormatter.java#L239
   *
   * @param value the number value to format
   * @param currency the currency code for the currency you wish to add (eg 'USD', 'AUD', 'GBP')
   * @param locale the locale to determine the format of the result (defaults to 'en_US')
   * @param maximumFractionDigits the maximum number of fraction digits to keep
   * @param minimumFractionDigits the minimum number of fraction digits to keep
   * @param useGrouping whether to use separator between thousands
   * @param style whether to format `currency` or `decimal`
   * @returns The formatted amount with correct number format based on the locale and currency
   */
  formatNumber: function formatNumber(_ref) {
    var value = _ref.value,
        currency = _ref.currency,
        _ref$locale = _ref.locale,
        locale = _ref$locale === void 0 ? 'en_US' : _ref$locale,
        maximumFractionDigits = _ref.maximumFractionDigits,
        minimumFractionDigits = _ref.minimumFractionDigits,
        useGrouping = _ref.useGrouping,
        style = _ref.style;
    var options = {
      currency: currency,
      currencyDisplay: 'code',
      maximumFractionDigits: maximumFractionDigits,
      minimumFractionDigits: minimumFractionDigits,
      style: style,
      useGrouping: useGrouping
    };
    var formattedCurrency = getNumberFormat(getSanitizedLocaleForIntl(locale), options).format(value);
    return formattedCurrency;
  },

  /**
   * Formats the specified date for the given locale and date.
   *
   * @param date the date value to format
   * @param weekday the format of weekday you wish to get (eg 'narrow', 'short', 'long')
   * @param era the era format for the date
   * @param year the format of year you wish to get (eg 'numeric', '2-digit')
   * @param month the format of month you wish to get (eg 'numeric', '2-digit', 'narrow', 'short', 'long')
   * @param day the format of day you wish to get (eg 'numeric', '2-digit')
   * @param hour the format of hour you wish to get (eg 'numeric', '2-digit')
   * @param minute the format of minute you wish to get (eg 'numeric', '2-digit')
   * @param second the format of second you wish to get (eg 'numeric', '2-digit')
   * @param timeZone timeZone for the date object
   * @param locale the locale to determine the format of the result, default value is 'en_US'
   * @returns The formatted string with correct date format based on the locale
   */
  formatDateTime: function formatDateTime(_ref2) {
    var date = _ref2.date,
        weekday = _ref2.weekday,
        era = _ref2.era,
        year = _ref2.year,
        month = _ref2.month,
        day = _ref2.day,
        hour = _ref2.hour,
        minute = _ref2.minute,
        second = _ref2.second,
        timeZone = _ref2.timeZone,
        _ref2$locale = _ref2.locale,
        locale = _ref2$locale === void 0 ? 'en_US' : _ref2$locale;
    var options = {
      weekday: weekday,
      era: era,
      year: year,
      month: month,
      day: day,
      hour: hour,
      minute: minute,
      second: second,
      timeZone: timeZone
    };
    return getDateTimeFormat(getSanitizedLocaleForIntl(locale), options).format(date);
  }
};
export default I18nFormatter;
//# sourceMappingURL=i18nFormatter.js.map